import { useTranslation } from 'react-i18next';
import myImage08 from '../image/08.jpg';
import myImage09 from '../image/09.jpg';
import myImage10 from '../image/10.jpg';
import myImage11 from '../image/11.jpg';

export default function Design() {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="design" className="py-20 sm:py-32 bg-gradient-to-br from-[#faf6f0] to-[#fdf9f4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-20">
          <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-[#3a2a1a] mb-4">
            <span className="text-[#b8864e]">{t('design_title_highlight_1')}</span> {t('design_title_1')}
            <br />
            {t('design_title_2')} <span className="text-[#b8864e]">{t('design_title_highlight_2')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 mb-16 sm:mb-32">
          <div className="lg:col-span-1">
            <div className="group relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl h-[280px] sm:h-[400px] lg:h-full lg:min-h-[600px]">
              <img
                src = {myImage08}
                alt={t('design_label_eco')}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-500"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 bg-[#3a2a1a]/85 backdrop-blur-sm text-[#f0d9b5] px-4 sm:px-6 py-2 sm:py-3 rounded-lg">
                <p className="font-medium whitespace-nowrap text-sm sm:text-base">{t('design_label_eco')}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-6 sm:gap-8">
            <div className="group relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl h-[200px] sm:h-[280px]">
              <img
                  src = {myImage09}
                alt={t('design_label_creative')}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-500"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 bg-[#3a2a1a]/85 backdrop-blur-sm text-[#f0d9b5] px-4 sm:px-6 py-2 sm:py-3 rounded-lg">
                <p className="font-medium whitespace-nowrap text-sm sm:text-base">{t('design_label_creative')}</p>
              </div>
            </div>

            <div className="group relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl h-[200px] sm:h-[280px]">
              <img
                  src = {myImage10}
                alt={t('design_label_craft')}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-500"></div>
              <div className="absolute bottom-4 sm:bottom-6 left-4 sm:left-6 bg-[#3a2a1a]/85 backdrop-blur-sm text-[#f0d9b5] px-4 sm:px-6 py-2 sm:py-3 rounded-lg">
                <p className="font-medium whitespace-nowrap text-sm sm:text-base">{t('design_label_craft')}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="group relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl mb-10 sm:mb-12">
          <div className="w-full h-[250px] sm:h-[400px] lg:h-[500px]">
            <img
                src = {myImage11}
              alt="Design Process"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-all duration-500"></div>
        </div>

        <div className="text-center space-y-6 sm:space-y-8">
          <p className="leading-relaxed">
            <span className="text-[#a08060] italic font-light text-4xl sm:text-5xl lg:text-6xl">{t('design_quote_light')}</span>
            <br />
            <span className="block mt-4 sm:mt-6 text-3xl sm:text-4xl lg:text-5xl text-[#3a2a1a] font-bold">{t('design_quote_bold')}</span>
          </p>
          <button
            onClick={scrollToContact}
            className="bg-[#3a2a1a] text-[#f0d9b5] px-8 sm:px-10 py-3 sm:py-4 rounded-full font-medium hover:bg-[#b8864e] transition-colors whitespace-nowrap cursor-pointer text-sm sm:text-base">
            {t('design_explore')}
          </button>
        </div>

        <div className="mt-16 sm:mt-32 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-12">
          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-[#b8864e] rounded-full">
              <i className="ri-leaf-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#3a2a1a] mb-3 sm:mb-4">{t('design_eco_title')}</h3>
            <p className="text-[#7a6050] leading-relaxed text-sm sm:text-base">{t('design_eco_desc')}</p>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-[#b8864e] rounded-full">
              <i className="ri-scissors-cut-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#3a2a1a] mb-3 sm:mb-4">{t('design_original_title')}</h3>
            <p className="text-[#7a6050] leading-relaxed text-sm sm:text-base">{t('design_original_desc')}</p>
          </div>

          <div className="text-center">
            <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center mx-auto mb-4 sm:mb-6 bg-[#b8864e] rounded-full">
              <i className="ri-hand-heart-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#3a2a1a] mb-3 sm:mb-4">{t('design_quality_title')}</h3>
            <p className="text-[#7a6050] leading-relaxed text-sm sm:text-base">{t('design_quality_desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
